import { styled } from '@linaria/react';

function CurlyBracket() {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 24"
      preserveAspectRatio="none"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d={`
          M 0 24
          C 0 -10
            200 18
            200 0
          C 200 18
            400 -10
            400 24
        `}
      />
    </Svg>
  );
}

const Svg = styled.svg`
  display: block;
  overflow: visible;
  fill: none;

  path {
    fill: none;
    stroke: var(--color-text);
    stroke-width: 2px;
    vector-effect: non-scaling-stroke;
  }
`;

export default CurlyBracket;
